import { lowerEnvironments, produstionEnvironments } from '@tgg/common-types';

export const isLowerEnv = (envString: string) =>
    lowerEnvironments.includes(envString as any);

export const isProductionEnv = (envString: string) =>
    produstionEnvironments.includes(envString as any);
